<template>
  <div class="about">
    <Header/>
    <Services/>
    <ProductsCarousel title="Our latest productions"/>
  </div>
</template>

<script>
import Header from '@/components/about/Header.vue';
import Services from '@/components/about/Services.vue';
import ProductsCarousel from '@/components/ProductsCarousel.vue';

export default {
  name: 'about',
  components: {
    Header,
    Services,
    ProductsCarousel,
  },
};
</script>

<style lang="stylus" scoped>
  @import '../styles/variables';
  .about{
    min-height: 100vh;
  }
</style>
